/*
saikrishna 10/04/2022 2698823069 bugFix: Fixed CM bugs
*/
import React from 'react';
import {Button, Typography, makeStyles} from '@material-ui/core';
import {deleteClientContact} from '../../../../redux/reducers/client-maintainance/ClientContact';
import {useDispatch} from 'react-redux';

const useStyles = makeStyles((theme) => ({
  buttonRoot: {
    'lineHeight': 1.75,
    [theme.breakpoints.down('md')]: {
      lineHeight: 1.5,
      padding: '6px 15px',
    },
    '& .MuiButton-label': {
      fontSize: '0.813rem',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.688rem',
        letterSpacing: 1,
      },
    },
  },
}));

function DeleteClient({rowData, handleDeleteClose, handleClose}) {
  const dispatch = useDispatch();
  const handleSubmit = () => {
    dispatch(deleteClientContact(rowData?.clntContactId));
  };

  const classes = useStyles();
  return (
    <>
      <div className="col text-center mt-2 mb-4">
        <Typography variant="h4">
        Do you want to delete the client contact - {rowData.contactName}?
        </Typography>
      </div>

      <div className="d-flex justify-content-center mt-2">
        <Button
          type="button"
          variant="contained"
          className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
          onClick={() => handleDeleteClose()}
        >
            No
        </Button>
        <Button
          type="submit"
          variant="contained"
          className={`mx-1 ${classes.buttonRoot}`}
          onClick={() => handleSubmit()}
        >
            Yes
        </Button>
      </div>

    </>
  );
}

export default DeleteClient;
